import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    width: { type: FIELD_TYPES.TEXT, label: "Max Width (%)" },
    ...SharedAdvancedFieldsConfig,
    noImageWidth: { type: FIELD_TYPES.BOOLEAN, label: "No Image Width" },
    tagTextSize: { type: FIELD_TYPES.TEXT, label: "Tag Text Size" }
  }
};
